import { useCallback, useState } from "react";

export function useAcceptCookies() {
  const { acceptValue, onAcceptAllHandler } = useAcceptValue();
  const {isCookiesSettingsOpen, onOpenCookiesSettinsHandler, onCloseCookiesSettinsHandler} = useCookiesSettings();

  const isConfirmationHidden = Boolean(acceptValue);

  return {
    onAcceptAllHandler,
    isConfirmationHidden,

    isCookiesSettingsOpen,
    onOpenCookiesSettinsHandler,
    onCloseCookiesSettinsHandler,
  };
}

function useAcceptValue() {
  const [acceptValue, setAcceptValue] = useState(() => {
    const storeAcceptValue = localStorage.getItem("acceptCookies");
    return storeAcceptValue?.includes("statistical");
  });

  const onAcceptAllHandler = useCallback(() => {
    setAcceptValue(true);
    localStorage.setItem("acceptCookies", "statistical");
  }, []);

  return { acceptValue, onAcceptAllHandler };
}

function useCookiesSettings() {
  const [isCookiesSettingsOpen, setOpenState] = useState(false);

  const onOpenCookiesSettinsHandler = useCallback(() => setOpenState(true), []);
  const onCloseCookiesSettinsHandler = useCallback(() => setOpenState(false), []);

  return { isCookiesSettingsOpen, onOpenCookiesSettinsHandler, onCloseCookiesSettinsHandler };
}
